import { useState } from "react";
import { useSearchParams, useNavigate } from "react-router-dom";
import api, { formatApiErrorDetail } from "../api";
import { PasswordInput, PasswordStrength } from "../components/PasswordInput";

export default function ResetPasswordPage() {
  const [params] = useSearchParams();
  const navigate = useNavigate();
  const token = params.get("token") || "";
  const [pw, setPw] = useState("");
  const [pw2, setPw2] = useState("");
  const [error, setError] = useState("");
  const [done, setDone] = useState(false);
  const [loading, setLoading] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setError("");
    if (pw !== pw2) { setError("Les deux mots de passe ne correspondent pas"); return; }
    setLoading(true);
    try {
      await api.post("/auth/reset-password", { token, new_password: pw });
      setDone(true);
    } catch (err) {
      setError(formatApiErrorDetail(err.response?.data?.detail) || err.message);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen bg-[#0A0A0A] flex items-center justify-center p-6">
      <div className="w-full max-w-md">
        <h1 className="font-display text-5xl text-white leading-none mb-2">GYM<span className="text-[#FF3B30]">TRACK</span></h1>
        {done ? (
          <div data-testid="reset-success" className="mt-6">
            <p className="text-white text-lg">✅ Mot de passe mis à jour !</p>
            <button data-testid="reset-goto-login-button" onClick={() => navigate("/")}
              className="mt-4 w-full h-12 bg-[#FF3B30] text-white font-display text-2xl tracking-wide hover:bg-[#e0322a] transition-colors">
              SE CONNECTER
            </button>
          </div>
        ) : (
          <>
            <p className="text-[#B0B0B4] text-sm mb-6">Choisis ton nouveau mot de passe (8 caractères minimum).</p>
            <form onSubmit={submit} className="space-y-3">
              <PasswordInput testId="reset-password-input" placeholder="Nouveau mot de passe"
                value={pw} onChange={(e) => setPw(e.target.value)} />
              <PasswordStrength password={pw} />
              <PasswordInput testId="reset-password-confirm-input" placeholder="Confirme le mot de passe"
                value={pw2} onChange={(e) => setPw2(e.target.value)} />
              {error && <p data-testid="reset-error" className="text-[#FF3B30] text-sm">{error}</p>}
              <button data-testid="reset-submit-button" disabled={loading}
                className="w-full h-12 bg-[#FF3B30] text-white font-display text-2xl tracking-wide hover:bg-[#e0322a] active:scale-[0.98] transition-colors disabled:opacity-50">
                {loading ? "..." : "RÉINITIALISER"}
              </button>
            </form>
          </>
        )}
      </div>
    </div>
  );
}
